export default class AddressService {
  constructor(httpService) {
    this.http = httpService;
  }

  async getAddressesByZipCode(zip) {
    return this.http.get(`/cp/${zip}`);
  }
}